<template>
  <v-row dense v-if="filteredModules.length > 0">
    <template v-for="mod in modules" :key="mod.name">
      <v-col cols="12" sm="6" lg="4" xl="3" v-if="!mod.hideInNav">
        <v-badge v-if="mod.badgeContent" :content="mod.badgeContent" color="error-darken-1" class="btn-card" bordered>
          <AppDashboardModule :mod="mod" />
        </v-badge>
        <AppDashboardModule v-else :mod="mod" />
      </v-col>
    </template>
  </v-row>
  <v-alert type="info" v-else>
    Es sind keine Module verfügbar
  </v-alert>
</template>

<script lang="ts" setup>
import {DashboardModule} from '@/util/dashboard';
import {PropType, computed} from 'vue';
import AppDashboardModule from './AppDashboardModule.vue';

const props = defineProps({
  modules: {
    type: Array as PropType<DashboardModule[]>,
    required: true,
  },
});

const filteredModules = computed(() => props.modules.filter((mod) => !mod.hideInNav));

defineExpose({
  AppDashboardModule,
  filteredModules,
});
</script>

<style>
.btn-card {
  height: auto !important;
  min-height: 6rem !important;
  display: flex !important;
  align-items: stretch !important;
  justify-content: stretch !important;
  padding: initial !important;
  min-width: none !important;
  text-transform: none;
}

.btn-card .v-badge__wrapper {
  justify-content: stretch;
  flex-grow: 1;
}
</style>

<style scoped>
:deep(.v-badge__badge) {
  z-index: 1;
  inset: -4px -4px auto auto !important;
  border-radius: 16px;
  font-size: 16px;
  height: 24px;
  min-width: 24px;
}
</style>
